import { createStore } from "vuex";
import AuthenticatedClient from "@/carto-node/lib/clients/authenticated.js";
import exportStore from "./modules/exportStore";
import engineStore from "./modules/engineStore";
import timelineStore from "./modules/timelineStore";  
import sidebarStore from "./modules/sidebarStore";

// Store Modules
import user from "./modules/user";
import maps from "./modules/maps/carto";
import search from "./modules/search";
import datahubLayers from "./modules/datahub";
import selectedMaps from "./modules/maps/selected";
import starmapSelected from "./modules/maps/starmap-selected";
import importMaps from "./modules/import";
import auth from "./modules/auth"

const storeOptions = {
  state: {
    client: null
  },
  getters: {},
  modules: {
    user,
    maps,
    datahubLayers,
    importMaps,
    auth,
    search,
    exportStore,
    engineStore,
    selectedMaps,
    timelineStore,
    sidebarStore,
    starmapSelected
  },
  mutations: {
    setClient(state, client) {
      state.client = client
    }
  },
  plugins: [
    store => {
      const CARTODB_AUTH_SERVER = process.env.VUE_APP_CARTODB_AUTH_SERVER;
      // 初始化默认为dev用户
      const client = new AuthenticatedClient(`${CARTODB_AUTH_SERVER}/user/dev`);
      store.commit("setClient", client);
    }
  ]
};
export default createStore(storeOptions);
